module.exports = __webpack_public_path__ + "files/b8129376b0429b17fff75f87cb450196.svg";